module.exports = __webpack_public_path__ + "img/loginimg.b578393a.png";